import { render, staticRenderFns } from "./pos_discount.vue?vue&type=template&id=80701518"
import script from "./pos_discount.vue?vue&type=script&lang=js"
export * from "./pos_discount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports